import { Spacing } from '@approvalmax/ui/src/components';
import { browserHelpers } from '@approvalmax/utils';
import { AppleAppStore, GooglePlay } from 'modules/sprites';
import { memo } from 'react';

import MobileLogo from '../MobileLogo/MobileLogo';
import { messages } from './MobileSuccessInfo.messages';
import {
    Root,
    SuccessContent,
    SuccessDownloadButton,
    SuccessDownloadLink,
    SuccessSectionScrollable,
    SuccessText,
} from './MobileSuccessInfo.styles';

const MobileSuccessInfo = memo(() => {
    return (
        <Root>
            <SuccessSectionScrollable>
                <Spacing height={40} />

                <MobileLogo />

                <SuccessContent>
                    <SuccessText>
                        {browserHelpers.isIphone()
                            ? messages.successTextIPhone({
                                  br: <br />,
                              })
                            : messages.successTextAndroid({
                                  br: <br />,
                              })}
                    </SuccessText>

                    {browserHelpers.isIphone() && (
                        <SuccessDownloadButton>
                            <SuccessDownloadLink
                                href='https://itunes.apple.com/us/app/approvalmax/id954804220'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <AppleAppStore width={175} height={50} />
                            </SuccessDownloadLink>
                        </SuccessDownloadButton>
                    )}

                    {browserHelpers.isAndroid() && (
                        <SuccessDownloadButton>
                            <SuccessDownloadLink
                                href='https://play.google.com/store/apps/details?id=com.approvalmax&hl=en'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <GooglePlay width={175} height={50} />
                            </SuccessDownloadLink>
                        </SuccessDownloadButton>
                    )}
                </SuccessContent>
            </SuccessSectionScrollable>
        </Root>
    );
});

export default MobileSuccessInfo;
